import { createContext, useContext } from "react";
import type { FolderPathSegment } from "@/domains/documents/utils/folderPathResolver";

export interface DocBreadcrumbsContextValue {
  buildingId: string;
  /** Breadcrumb segments for a filename, or null/undefined when unknown. */
  getSegments: (filename: string) => FolderPathSegment[] | null | undefined;
}

/**
 * WHA-3829: lets every DocChip rendered inside the chat window upgrade its
 * hover tooltip to the interactive project → folder → filename breadcrumb
 * (DocumentBreadcrumbHover) without threading props through the message
 * tokenizer and the chip group/collapsed variants. Chips rendered outside a
 * provider (PM surfaces wrap chips externally) are unaffected.
 */
export const DocBreadcrumbsContext = createContext<DocBreadcrumbsContextValue | null>(null);

export function useDocBreadcrumbs(): DocBreadcrumbsContextValue | null {
  return useContext(DocBreadcrumbsContext);
}
